export default {
  namespaced: true,
  state: {
    navToDetailsData: {},
    collapse: {},
    stateTypes: []
  },
  mutations: {
    // 用于保存地图infowindow的选中某子设备，外层页面监听此值变化，触发显示子设备详情事件
    changeNavToDetailsData (state, info) {
      state.navToDetailsData = info
    },
    // 用于左侧菜单栏尺寸变化时候，触发地图标尺的位置计算
    toggleCollapse (state, date) {
      state.collapse = date
    },
    // 保存地图数据分类
    saveStateTypes (state, stateTypes) {
      state.stateTypes = stateTypes
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/business.js